import { serverResponse } from "../util/fakeServer";
import DefaultManager from "./Default.manager";

class ErgonManager extends DefaultManager {
  signboardId;

  constructor(signboardId) {
    super(signboardId);
    this.signboardId = signboardId;
  }

  getAnalyticsId() {
    switch (this.signboardId) {
      case 46:
        return serverResponse.config.ga_tracking_id;

      default:
        return serverResponse.config.ga_tracking_id;
    }
  }
}

export default ErgonManager;
